import PropTypes from 'prop-types';
import React from 'react';
import { SmallText } from '../../../typography';
import { OptionsToggleSC, OptionSC } from './options-toggle.styled';

const OptionsToggle = ({ onChange, options, value }) => {
  return (
    <OptionsToggleSC>
      {options.map((opt) => (
        <OptionSC
          className="option"
          onClick={() => onChange(opt)}
          isActive={value === opt.value}
          key={opt.value}
        >
          <span className="bold">{opt.text ?? opt.text} </span>
          {opt.subText ? <SmallText className="smaller grey">{opt.subText}</SmallText> : null}
        </OptionSC>
      ))}
    </OptionsToggleSC>
  );
};

OptionsToggle.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number.isRequired,
      text: PropTypes.string,
      subText: PropTypes.string,
    })
  ),
};

export default OptionsToggle;
